import axios from 'axios';
import { SERVER } from '../variables';

export const login = async (username, password) => {
    const url = `${SERVER}/auth`;
    const { data } = await axios.post(url, { username, password });
    return data;
};
